import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

import { CUSTOM_ICON_BUTTON_SIZE, CUSTOM_ICON_BUTTON_VARIANT, getFontSize } from './lib';

export const useStyles = makeStyles(
  (theme) => ({
    root: (props) => ({
      position: 'relative',
      ...calculateStyles(theme, props),

      '& svg': {
        fontSize: 'inherit',
      },
    }),
    label: {},
    loading: {
      '& $label': {
        visibility: 'hidden',
      },
    },
    spinner: {
      position: 'absolute',
      visibility: 'visible',
    },
  }),
  { name: 'CustomIconButton' }
);

/**
 * Dynamically calculate styles, so it will be easier to override them in-place
 * @param theme
 * @param props
 * @returns {{}}
 */
const calculateStyles = (theme, props) => {
  // Padding
  const padding = calculatePadding(theme, props.size);

  // Sizes
  const fontStyles = calculateFontStyles(theme, props.size);

  // Variants
  const variantStyles = getVariantStyles(props.variant);

  return {
    padding,
    ...fontStyles,
    ...variantStyles,
  };
};

const calculatePadding = (theme, size) => {
  switch (size) {
    case CUSTOM_ICON_BUTTON_SIZE.small:
      return theme.spacing(0.5);

    case CUSTOM_ICON_BUTTON_SIZE.large:
    case CUSTOM_ICON_BUTTON_SIZE.medium:
    default:
      return theme.spacing(1);
  }
};

const calculateFontStyles = (theme, size) => ({
  fontSize: getFontSize(size),
});

const VARIANT_STYLES = {
  [CUSTOM_ICON_BUTTON_VARIANT.default]: {
    backgroundColor: 'transparent',
    color: COLORS.gray.gray40,

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },

    '&[disabled]': {
      color: COLORS.gray.gray50,
    },
  },

  [CUSTOM_ICON_BUTTON_VARIANT.primary]: {
    backgroundColor: COLORS.primary.default,
    color: COLORS.neutral.white,

    '&:hover': {
      backgroundColor: COLORS.primary.active,
    },

    '&[disabled]': {
      backgroundColor: COLORS.gray.gray60,
      color: COLORS.neutral.white,
    },
  },

  [CUSTOM_ICON_BUTTON_VARIANT.silver]: {
    backgroundColor: 'transparent',
    color: COLORS.gray.gray40,

    '&:hover': {
      backgroundColor: COLORS.primary.silver,
    },

    '&[disabled]': {
      color: COLORS.gray.gray50,
    },
  },

  [CUSTOM_ICON_BUTTON_VARIANT.outlined]: {
    backgroundColor: COLORS.gray.gray90,
    color: COLORS.gray.gray40,

    '&:hover': {
      backgroundColor: COLORS.primary.silver,
    },

    '&[disabled]': {
      backgroundColor: COLORS.gray.gray90,
      color: COLORS.gray.gray50,
    },
  },
};

const getVariantStyles = (variant) => ({
  ...VARIANT_STYLES[variant],
});
